import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-api-endpoint-with-token',
  templateUrl: './userapi-api-endpoint-with-token.component.html'
})
export class UserApiApiEndpointWithTokenComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
